import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Label } from './ui/label';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { Columns3, PackageOpen } from 'lucide-react';
import { postSizes } from '../data/mockPricing';

const PostOptions = ({ includePosts, postSize, onIncludePostsChange, onPostSizeChange, selectedModel }) => {
  if (!selectedModel) return null;

  return (
    <Card className="transition-all duration-300 hover:shadow-lg">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Columns3 className="w-5 h-5 text-emerald-600" />
          Steher-Optionen
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Posts or Panels Only */}
        <div className="space-y-3">
          <Label className="text-base font-medium">Installation</Label>
          <RadioGroup value={includePosts ? 'with-posts' : 'panels-only'} onValueChange={(value) => onIncludePostsChange(value === 'with-posts')}>
            <div className="flex items-center space-x-2 p-3 rounded-lg border-2 border-gray-200 hover:border-emerald-300 transition-all cursor-pointer">
              <RadioGroupItem value="with-posts" id="with-posts" />
              <Label htmlFor="with-posts" className="flex-1 cursor-pointer">
                <div className="font-medium">Mit Aluminium Steher</div>
                <p className="text-sm text-gray-500">Komplettsystem mit Steher</p>
              </Label>
            </div>
            
            <div className="flex items-center space-x-2 p-3 rounded-lg border-2 border-gray-200 hover:border-emerald-300 transition-all cursor-pointer">
              <RadioGroupItem value="panels-only" id="panels-only" />
              <Label htmlFor="panels-only" className="flex-1 cursor-pointer">
                <div className="font-medium">Nur Zaunelemente</div>
                <p className="text-sm text-gray-500">Für Mauermontage (ohne Steher)</p>
              </Label>
            </div>
          </RadioGroup>
        </div>

        {/* Post Size Selection - only show if posts are included */}
        {includePosts && (
          <div className="space-y-3 animate-slideUp">
            <Label className="text-base font-medium">Stehergröße wählen</Label>
            <RadioGroup value={postSize} onValueChange={onPostSizeChange}>
              {postSizes.map((size) => (
                <div 
                  key={size.id}
                  className={`flex items-center space-x-2 p-3 rounded-lg border-2 transition-all cursor-pointer ${
                    postSize === size.id 
                      ? 'border-emerald-500 bg-emerald-50' 
                      : 'border-gray-200 hover:border-emerald-300'
                  }`}
                >
                  <RadioGroupItem value={size.id} id={size.id} />
                  <Label htmlFor={size.id} className="flex-1 cursor-pointer">
                    <div className="font-medium">{size.label}</div>
                  </Label>
                </div>
              ))}
            </RadioGroup>
            
            <div className="bg-gradient-to-r from-blue-50 to-cyan-50 p-4 rounded-lg border border-blue-200">
              <div className="flex items-start gap-2">
                <PackageOpen className="w-5 h-5 text-blue-600 mt-0.5" />
                <div className="text-sm text-gray-700">
                  <p className="font-medium text-blue-900">Hinweis:</p>
                  <p>Alle Steher inkl. Abdeckkappe und Montageplatte</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {!includePosts && (
          <div className="bg-gradient-to-r from-amber-50 to-yellow-50 p-4 rounded-lg border border-amber-200 animate-slideUp">
            <div className="flex items-start gap-2">
              <PackageOpen className="w-5 h-5 text-amber-600 mt-0.5" />
              <div className="text-sm text-gray-700">
                <p className="font-medium text-amber-900">Nur Zaunelemente</p>
                <p>Ideal für Wandmontage oder wenn Sie bereits Steher haben</p>
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PostOptions;